module.exports = __webpack_public_path__ + "img/adminconf.313a8a7b.png";